import { useEffect, useState } from 'react';

/**
 * Mirrors Android's `ApiDebounce` (500ms, `WithdrawalViewModel.kt:66`).
 *
 * Returns `value` only after it has stopped changing for `delay` ms, so the
 * withdrawal breakdown fires once per pause instead of once per keystroke.
 */
export const DEFAULT_DEBOUNCE_MS = 500;

export default function useDebouncedValue<T>(
  value: T,
  delay: number = DEFAULT_DEBOUNCE_MS,
): T {
  const [debounced, setDebounced] = useState<T>(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debounced;
}
